// src/hooks/useApiErrorHandler.ts
import { useCallback } from 'react';
import axios, { AxiosError } from 'axios'; 
import { toast } from 'react-toastify';

// Genel bir API hatası tipi
interface IApiError {
    message: string;
    details?: any; // Validation error detayları için
}

/**
 * Merkezi API Hata Yönetimi Hook'u.
 * Hatanın tipini belirler (Axios, JS Error, vb.) ve kullanıcıya toast mesajı gösterir.
 * @returns {function} handleApiError fonksiyonu
 */
export const useApiErrorHandler = () => {
    
    // 💡 useCallback kullanarak hook'un stabil kalmasını sağlıyoruz
    const handleApiError = useCallback((error: unknown, defaultMessage: string = "İşlem sırasında bilinmeyen bir hata oluştu.") => {
        
        let displayMessage: string = defaultMessage;
        
        // 1. Axios hatası mı kontrolü
        if (axios.isAxiosError<IApiError>(error)) {
            const axiosError = error as AxiosError<IApiError>;
            
            // Sunucudan dönen yanıt var mı? (4xx veya 5xx)
            if (axiosError.response && axiosError.response.data) {
                // API'den gelen spesifik mesajı kullan
                displayMessage = axiosError.response.data.message || defaultMessage;

                // 💡 DEBUG: Konsola detayları logla (Geliştirme için önemlidir)
                console.error("API Error (Server Response):", axiosError.response.data);
            } else if (axiosError.request) {
                // İstek yapıldı ancak yanıt alınamadı (Network, CORS vb.)
                displayMessage = "Sunucuya ulaşılamadı. Lütfen internet bağlantınızı kontrol edin.";
            } else {
                // Axios'un kendi hata mesajı (request kurulum hatası)
                displayMessage = axiosError.message;
            }
            
        } else if (error instanceof Error) {
            // Standart JavaScript/TyperScript hatası
            displayMessage = error.message;
            console.error("Standard JS Error:", error);
            
        } else {
            // Bilinmeyen hata
            console.error("Unknown Error:", error);
            displayMessage = defaultMessage;
        }

        // 2. Toast mesajını göster
        toast.error(`Hata: ${displayMessage}`);

        // 3. (Opsiyonel) Hatanın tekrar fırlatılması, eğer çağıran kodun 
        // daha fazla işlem yapması gerekiyorsa (Zustand catch bloğunda olduğu gibi)
        // throw error; 

    }, []);

    return { handleApiError };
};